import { isOneOfTags } from 'anodum';
import setCaretAtTheBeginningOfNode from './set-caret-at-the-beginning-of-node';
import { EDITABLE_ELEMENTS } from '../constants/editable-elements';

const handleEmptyLastListItem = (listItem) => {
  const { parentNode, ownerDocument: liveDocument } = listItem;
  let newElement;
  if (listItem.childElementCount && isOneOfTags(listItem.children[0], EDITABLE_ELEMENTS)) {
    [newElement] = listItem.children;
  } else {
    newElement = liveDocument.createElement('p');
    newElement.append(...listItem.childNodes);
  }

  parentNode.insertAdjacentElement('afterend', newElement);
  listItem.remove();
  if (!parentNode.childElementCount) {
    parentNode.remove();
  }

  setCaretAtTheBeginningOfNode(newElement.querySelector('br'));
};

export default handleEmptyLastListItem;
